import React from 'react';
import classNames from 'classnames';

import styles from './index.module.scss';

export interface AuthorProps {
  name: string | React.ReactNode;
  description?: string | React.ReactNode;
  avatar?: React.ReactNode;
  judge?: number;
  positionJudge?: number;
  style?: React.CSSProperties;
  className?: string;
}

const Author: React.FC<AuthorProps> = ({
  name,
  description,
  avatar,
  judge,
  positionJudge,
  className,
  ...otherProps
}) => (
  <div {...otherProps} className={classNames('flex items-center', className)}>
    {avatar || null}
    <div className='inline-block ml-2 flex-auto w-0'>
      <div className='text-sm text-[#15161F] font-medium truncate'>{name}</div>
      <div
        className={classNames('text-xs text-[#AFB1BC] pt-1 truncate', styles.occup, {
          [styles.occup_cr]: Boolean(judge),
          [styles.occup_cr_p]: Boolean(positionJudge),
        })}
      >
        {description}
      </div>
    </div>
  </div>
);

export default React.memo(Author);
